export class UtilityService {

    html(target, content) {
        if (target.includes("#")) {
            var id = target.replace("#", "");
            var el = document.getElementById(id);
            if (el == null) return;
            el.innerHTML = content;

        }
        if (target.includes(".")) {
            var cls = target.replace(".", "");
            var rows = document.getElementsByClassName(cls);
            for(var i=0; i < rows.length; i++) {
                rows[i].innerHTML = content;
            }
        }
    }

    hide(target) {
        if (target.includes("#")) {
            var id = target.replace("#", "");
            var el = document.getElementById(id);
            if (el == null) return;
            el.style.visibility = "hidden";
            el.style.display = "none";

        }
        if (target.includes(".")) {
            var cls = target.replace(".", "");
            var rows = document.getElementsByClassName(cls);
            for(var i=0; i < rows.length; i++) {
                if (rows[i] == null) return;
                rows[i].style.visibility = "hidden";
                rows[i].style.display = "none";
            }
        }
    }

    show(target) {
        if (target.includes("#")) {
            var id = target.replace("#", "");
            var el = document.getElementById(id);
            if (el == null) return;
            el.style.visibility = "visible";
            el.style.display = "";

        }
        if (target.includes(".")) {
            var cls = target.replace(".", "");
            var rows = document.getElementsByClassName(cls);
            for(var i=0; i < rows.length; i++) {
                if (rows[i] == null) return;
                rows[i].style.visibility = "visible";
                rows[i].style.display = "";
            }
        }
    }

    clear(target) {
        if (target.includes("#")) {
            var id = target.replace("#", "");
            var el = document.getElementById(id);
            if (el == null) return;
            el.innerHTML = "";

        }
        if (target.includes(".")) {
            var cls = target.replace(".", "");
            var rows = document.getElementsByClassName(cls);
            for(var i=0; i < rows.length; i++) {
                rows[i].innerHTML = "";
            }
        }
    }

    element(el) {
        return document.getElementById(el);
    }

    elements(cls) {
        return document.getElementsByClassName(cls);
    }

    now() {
		return new Date().getTime() / 1000;
	}

    dateTimeNow() {
        var today = new Date();
        var month = today.getMonth()+1;
        if (month < 10) {
            month = "0" + month;
        }
        var date = today.getDate();
        if (date < 10) {
            date = "0" + date;
        }

        var hours = today.getHours();
        if (hours < 10) {
            hours = "0" + hours;
        }

        var minutes = today.getMinutes();
        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        var seconds = today.getSeconds();
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        var date = today.getFullYear()+'-'+month+'-'+date;
        var time = hours + ":" + minutes + ":" + seconds;
        var dateTime = date+' '+time;
        return dateTime;
    }

    generateKey() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
          );
    }

    randomizeArray(unshuffled) {
        return unshuffled
        .map((a) => ({sort: Math.random(), value: a}))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value);
    }

    showLoader(id) {
		const html =`
            <div class="row" style="display:inline-block">
                <div style="text-align: block" class="loader"></div>
            </div>
		`;
		this.html(id, html);
	}
}

setTimeout(function(){
    _svc.util = new UtilityService();
}, 1);